export default __webpack_public_path__ + "static/media/rhs.ab2f52bb.png";